 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Account Period
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAcctPeriodFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAcctPeriodFilterForm"
                            v-model="filtersAcctPeriod.acctPerMth"
                            :label="filtersAcctPeriodLabel.acctPerMth"
                            :error-messages="errors.collect('acctPerMth')"
                            data-vv-name="acctPerMth"
                            :data-vv-as="filtersAcctPeriodLabel.acctPerMth"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAcctPeriodFilterForm"
                            v-model="filtersAcctPeriod.acctPerYr"
                            :label="filtersAcctPeriodLabel.acctPerYr"
                            :error-messages="errors.collect('acctPerYr')"
                            data-vv-name="acctPerYr"
                            :data-vv-as="filtersAcctPeriodLabel.acctPerYr"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearAcctPeriodFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doAcctPeriodFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="acctPeriodHeaders"
          :items="acctPeriodItems"
          v-bind:options.sync="paginationAcctPeriod"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsAcctPeriod"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ formatDisplayDate(row.item.acctPerEndDate) }}</td>
              <td>{{ row.item.acctPerMth }}</td>
              <td>{{ row.item.acctPerYr }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAcctPeriod(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      actionName: '',
      filtersAcctPeriodLabel: {
        acctPerMth: 'Account Period Month',
        acctPerYr: 'Account Period Year'
      },
      filtersAcctPeriod: {
        acctPerMth: '',
        acctPerYr: '',
        modNo: ''
      },
      acctPeriodItems: [],
      totalItemsAcctPeriod: 0,
      acctPeriodHeaders: [
        { text: 'Acct Period End Date', align: 'left', value: 'acctPerEndDate' },
        { text: 'Acct Period Month', align: 'left', value: 'acctPerMth' },
        { text: 'Acct Period Year', align: 'left', value: 'acctPerYr' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAcctPeriod: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearAcctPeriodFilters()
  },
  methods: {
    closeDialog() {
      this.filtersAcctPeriod.acctPerMth = ''
      this.filtersAcctPeriod.acctPerYr = ''
      this.filtersAcctPeriod.modNo = ''
      this.$emit('close')
    },
    doClearAcctPeriodFilters() {
      this.filtersAcctPeriod.acctPerMth = ''
      this.filtersAcctPeriod.acctPerYr = ''
      if (this.modeNo !== '') {
        this.filtersAcctPeriod.modNo = this.modeNo
      } else {
        this.filtersAcctPeriod.modNo = ''
      }
      this.fetchAcctPeriodData2()
    },
    doAcctPeriodFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAcctPeriodFilterForm').then((result) => {
        if (result) {
          this.paginationAcctPeriod.page = 1
          if (this.modeNo !== '') {
            this.filtersAcctPeriod.modNo = this.modeNo
          }
          this.fetchAcctPeriodData2()
        }
      })
    },
    assignAcctPeriod(data) {
      this.$emit('assign-acct-period-info', data)
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    }
  },
  watch: {
    'paginationAcctPeriod': function (value) {
      this.fetchAcctPeriodData2()
    },
    boolRefresh: function (value) {
      if (value) {
        this.doClearAcctPeriodFilters()
      }
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    modeNo: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
